import breakpoints from './breakpoints';

const media = {
    mobile320: `@media screen and (min-width: ${breakpoints.mobile320})`,
    retina: `@media screen and (min-width: ${breakpoints.mobile320}) (-webkit-min-device-pixel-ratio: 2), (min-resolution: 192dpi)`,
    tablet648: `@media screen and (min-width: ${breakpoints.tablet648})`,
    tablet720: `@media screen and (min-width: ${breakpoints.tablet720})`,
    retina720: `@media screen and (min-width: ${breakpoints.tablet720}) and (-webkit-min-device-pixel-ratio: 2), screen and (${breakpoints.tablet720}) and (min-resolution: 192dpi)`,
    tablet1080: `@media screen and (min-width: ${breakpoints.tablet1080})`,
    desktop1224: `@media screen and (min-width: ${breakpoints.desktop1224})`,
    desktop1352: `@media screen and (min-width: ${breakpoints.desktop1352})`,
    retina1352: `@media screen and (min-width: ${breakpoints.desktop1352}) and (-webkit-min-device-pixel-ratio: 2), screen and (${breakpoints.desktop1352}) and (min-resolution: 192dpi)`,
    desktop1440: `@media screen and (min-width: ${breakpoints.desktop1440})`,
    retina1440: `@media screen and (min-width: ${breakpoints.desktop1440}) and (-webkit-min-device-pixel-ratio: 2), screen and (${breakpoints.desktop1440}) and (min-resolution: 192dpi)`,
    desktop1920: `@media screen and (min-width: ${breakpoints.desktop1920})`,
};

export default media;
